import type { ReactNode } from 'react';
import { Container } from 'react-bootstrap';

interface StickyFooterProps {
  children: ReactNode;
}

/** Fixed bottom action bar (primary CTA + optional meta row) shared by every step page. */
export function StickyFooter({ children }: StickyFooterProps) {
  return (
    <div className="app-sticky-footer pb-safe">
      <Container className="py-2">{children}</Container>
    </div>
  );
}
